export default __webpack_public_path__ + "static/media/grocerybud.34a05f39.png";